// Company Landing ********************************************************************************
// pathname: /v1/company/landing
// ************************************************************************************************
import {
  useSwrApi, ApiCompanyLandingOk,
} from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch company landing page data.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 */
export const useSwrCompanyLanding = (locale = 'ro') => {
  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiCompanyLandingOk>({
    url: '/v1/company/landing',
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000 * 5, // 5 minutes
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
